/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Export_RealInputs */

const cs_portals_export_real = /** @type {(inputs: Portals_Export_RealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportovat`)
};

const en_portals_export_real = /** @type {(inputs: Portals_Export_RealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export now`)
};

/**
* | output |
* | --- |
* | "Export now" |
*
* @param {Portals_Export_RealInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_export_real = /** @type {((inputs?: Portals_Export_RealInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Export_RealInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_export_real(inputs)
	return cs_portals_export_real(inputs)
});